export const RATE_CONFIG_DATA                   = "RATE_CONFIG_DATA";
export const GET_RATE_CONFIG_DATA               = "GET_RATE_CONFIG_DATA";
export const SET_RATES_CONFIG_STEPS             = "SET_RATES_CONFIG_STEPS";
export const SET_RATES_CONFIG_STEPS_COPY             = "SET_RATES_CONFIG_STEPS_COPY";
export const SET_EXISTING_RATES_CONFIG_STEPS    = "SET_EXISTING_RATES_CONFIG_STEPS";
export const SET_RATESHEET_CONFIG_VARIABLES     = "SET_RATESHEET_CONFIG_VARIABLES";
export const SET_WINDOW_FIELDS_DATA             = "SET_WINDOW_FIELDS_DATA";